module.exports = __webpack_public_path__ + "static/media/quantum.5387c382.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/quantum.png
// module id = 472
// module chunks = 0